<template>
    <form v-on:submit.prevent="sendForm()">
        <div>
            <div class="row">
                <div class="col-xs-12" v-if="hasErrorMessageForField('text')">
                    <div
                        class="alert alert-danger alert-dismissible"
                        role="alert">
                        <p v-for="message of getErrorMessageForField('text')">
                            {{ message }}</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="input-group">
                        <input @focus="focusText()" @blur="unFocusedText()" v-model="text" placeholder="Kommentieren..." type="text"
                               class="form-control comment-input" :maxlength="maxCommentLength">
                        <span class="input-group-btn comment-button">
                          <button class="btn comment-button" :disabled="text.length === 0">
                            <i style="padding-left: 1rem; font-size: 1.5rem;" :class="{ disabled: text.length === 0 }"
                               class="dev-send-plane"
                               aria-hidden="true"></i>
                          </button>
                        </span>
                    </div>
                    <text-length-indicator :text="text" :max-text-length="maxCommentLength"/>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import {services} from "../../main";
import TextLengthIndicator from "../TextLengthIndicator";

export default {
    name: "CommentForCodeCommentForm",
    components: {TextLengthIndicator},
    props: {
        codeCommentId: {type: String, required: true, default: null}
    },
    data() {
        return {
            postRequestResult: {loaded: true, error: null},
            text: "",
            textFocused: false,
            maxCommentLength: 255,
        }
    },
    methods: {
        sendForm: function () {
            this.postRequestResult = services.rankTheCodeService.postCommentForCodeComment(this.codeCommentId, this.text);
        },
        hasErrorMessageForField(field) {
            return this.postRequestResult.error && this.postRequestResult.error.additionalData && this.postRequestResult.error.additionalData.fields[field];
        },
        getErrorMessageForField(field) {
            return this.postRequestResult.error.additionalData.fields[field]
        },
        focusText() {
            this.$emit('textFocused')
        },
        unFocusedText() {
            this.$emit('textUnfocused');
        },
    },
    watch: {
        "postRequestResult.loaded": function () {
            if (this.postRequestResult.loaded && this.postRequestResult.error === null) {
                this.$emit("successful", {
                    "codeCommentId": this.codeCommentId,
                    "commentId": this.postRequestResult.apiData.id,
                    "publicUserId": this.postRequestResult.apiData.publicUserId,
                    "text": this.text.trim(),
                });
                this.text = '';
            }
        },
    },
}
</script>

<style scoped>
.comment-button {
    background-color: transparent;
}

.comment-input {
    border: none;
    display: flex;
    padding: 2rem 2rem;
    background-color: #F4F8FB !important;
    border-radius: 10px;
    align-items: flex-end;
    overflow-x: hidden;
}

.input-group {
    background-color: #F4F8FB !important;
    padding-right: 2rem;
    margin-top: 1rem;
    border-radius: 10px;
}

.disabled {
    opacity: 0.5;
}
</style>
